import { Button } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ContactType, Section } from '../../../shared';
import { ContactInputs } from '../contact-inputs/contact-inputs.component';
import { useFieldArray, useFormContext } from 'react-hook-form';

export const SupportCaseContactInputs: FC = () => {
    const { t } = useTranslation();
    const { control } = useFormContext();

    const {
        fields: contactFields,
        append: appendContact,
        remove: removeContact,
    } = useFieldArray({
        control,
        name: 'contacts',
    });

    return (
        <Section title={t('contactInformation')}>
            {contactFields.map((field, index) => (
                <ContactInputs
                    key={field.id}
                    field={`contacts.${index}`}
                    onRemoveContact={() => removeContact(index)}
                />
            ))}
            <Button
                data-testid="add-contact"
                onClick={() => appendContact({ type: ContactType.Email, data: '', primaryContact: false })}
                color="secondary"
            >
                + {t('contactsAdd')}
            </Button>
        </Section>
    );
};
